<div class="wn-shell">
  <header class="wn-topbar">
    <div class="wn-topbar__inner">
      <a class="wn-brand" routerLink="/" [attr.aria-label]="'LANDING.BRAND.WORDMARK' | translate">
        <img class="wn-brand__icon" [src]="brandIconSrc" alt="" width="40" height="22" />
        <span class="wn-brand__wordmark">{{ 'LANDING.BRAND.WORDMARK' | translate }}</span>
      </a>

      @if (showNav) {
        <nav class="wn-topbar__nav" [attr.aria-label]="'NAV.PRIMARY' | translate">
          <a routerLink="/" fragment="modules">{{ 'LANDING.NAV.PRODUCT' | translate }}</a>
          <a routerLink="/" fragment="outcomes">{{ 'LANDING.NAV.WHY' | translate }}</a>
          <a routerLink="/" fragment="faq">{{ 'LANDING.NAV.FAQ' | translate }}</a>
        </nav>
      }

      <div class="wn-topbar__actions">
        <app-theme-switcher />
        <app-language-switcher />
        @if (showWorkspaceEntry) {
          <a routerLink="/dashboard" class="wn-topbar__link">
            <i class="pi pi-th-large" aria-hidden="true"></i>
            <span>{{ 'COMMON.ACTIONS.OPEN_WORKSPACE' | translate }}</span>
          </a>
        } @else if (!hideSignIn) {
          <a routerLink="/login" class="wn-topbar__link">{{ 'COMMON.ACTIONS.SIGN_IN' | translate }}</a>
        }
        <a routerLink="/" fragment="demo" class="wn-topbar__cta">{{ 'LANDING.NAV.BOOK_DEMO' | translate }}</a>
      </div>
    </div>
  </header>

  <main class="wn-main" [class.wn-main--framed]="!fullBleed">
    <ng-content></ng-content>
  </main>

  @if (showFooter) {
    <footer class="wn-footer">
      <div class="wn-footer__inner">
        <span class="wn-footer__brand">
          <img class="wn-footer__icon" [src]="brandIconSrc" alt="" width="40" height="22" />
          <span>{{ 'LANDING.BRAND.WORDMARK' | translate }}</span>
        </span>
        <span class="wn-footer__tagline">{{ 'LANDING.FOOTER.TAGLINE' | translate }}</span>
        <span class="wn-footer__spacer"></span>
        <nav class="wn-footer__links" [attr.aria-label]="'PUBLIC_CONTENT.LINKS.ARIA' | translate">
          @for (link of footerLinks; track link.path) {
            <a [routerLink]="link.path">{{ link.labelKey | translate }}</a>
          }
        </nav>
      </div>
    </footer>
  }

  @if (showAssistant) {
    <app-landing-assistant-widget />
  }
</div>
